import { Component } from "@angular/core";
import { FieldArrayType } from "@ngx-formly/core";

@Component({
  selector: "formly-add-facility",
  template: `

  <style>
      .card {
        box-shodow:none;
      }
    </style>

    <div *ngFor="let field of field.fieldGroup; let i = index" class="row p-2">

        <div ngbAccordion #acc="ngbAccordion" [closeOthers]="true" [animation]="false" (panelChange)="onPanelToggle($event)">
            <div ngbAccordionItem id="facility-panel">
                <div ngbAccordionHeader class="accordion-button custom-header">
                    <button ngbAccordionButton class="btn btn-transparent">
                    <fa-icon class="float-left mr-2" [icon]="['fas', openPanel ? 'chevron-down' : 'chevron-right']"></fa-icon>
                    <span>Facility</span>
                    </button>
                </div>
        
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <div>
                            <formly-field class="col" [field]="field"></formly-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        

    </div>
  `
})
export class AddFacilityAccordionTypeComponent extends FieldArrayType {

    openPanel: boolean = false;

    onPanelToggle(event) {
        this.openPanel = !this.openPanel;
    }
  
}

// Old accordion
        // <ngb-accordion
        //     #acc="ngbAccordion"
        //     [closeOthers]="true"
        //     (panelChange)="onPanelToggle($event)">
        //     <ngb-panel>
        //     <ng-template ngbPanelTitle>
        //         <fa-icon class="float-left  mr-2"  [icon]="['fas', openPanel ? 'chevron-down' : 'chevron-right']"></fa-icon>
        //         <span>Facility</span>                
        //     </ng-template>
        //     <ng-template ngbPanelContent>
        //         <formly-field class="col" [field]="field"></formly-field>
        //     </ng-template>
        //     </ngb-panel>
        // </ngb-accordion>